import { render, staticRenderFns } from "./li-item.vue?vue&type=template&id=1bcfab42&scoped=true"
import script from "./li-item.vue?vue&type=script&lang=js"
export * from "./li-item.vue?vue&type=script&lang=js"
import style0 from "./li-item.vue?vue&type=style&index=0&id=1bcfab42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcfab42",
  null
  
)

export default component.exports